import React from "react";
import { ButtonStyled } from "@nike/nike-design-system-components";

function formatShipTo(row) {
  const code = (row.shipToCode || "").trim();
  if (code) {
    return code;
  }
  const raw = row.shipTo;
  if (!raw || raw === "—") {
    return "—";
  }
  return String(raw).split("\n")[0].trim() || "—";
}

function PgIlpnModal({
  palletGroupRow,
  withCartonStatus = false,
  ilpnIds = [],
  cartonSummary,
  loading = false,
  loadError = null,
  onClose,
}) {
  const diverted =
    cartonSummary?.diverted ?? palletGroupRow?.diverted ?? 0;
  const palletised =
    cartonSummary?.palletised ?? palletGroupRow?.palletised ?? 0;

  if (!palletGroupRow) {
    return null;
  }

  return (
    <div
      className="pg-modal-backdrop"
      role="presentation"
      onClick={(e) => {
        if (e.target === e.currentTarget) {
          onClose();
        }
      }}
    >
      <div
        className="pg-modal pg-modal--ilpn"
        role="dialog"
        aria-modal="true"
        aria-labelledby="pg-ilpn-modal-title"
        style={{
          "--pg-ilpn-count": ilpnIds.length,
        }}
      >
        <div className="pg-modal__header">
          <div className="pg-modal__title" id="pg-ilpn-modal-title">
            ILPNs in {palletGroupRow.palletGroup}
          </div>
          <button
            type="button"
            className="pg-modal__close"
            onClick={onClose}
            aria-label="Close"
          >
            ×
          </button>
        </div>
        <div className="pg-modal__body pg-modal__body--ilpn">
          {loading && (
            <p className="pg-modal-loading" role="status">Loading ILPNs…</p>
          )}
          {loadError && !loading && (
            <p className="pg-modal-error" role="alert">{loadError}</p>
          )}
          <div className="pg-ilpn-info-grid">
            <div>
              <span className="pg-ilpn-info-label">ASN</span>
              <span className="pg-ilpn-info-value">{palletGroupRow.asn}</span>
            </div>
            <div>
              <span className="pg-ilpn-info-label">PO</span>
              <span className="pg-ilpn-info-value">{palletGroupRow.po}</span>
            </div>
            <div>
              <span className="pg-ilpn-info-label">Ship to</span>
              <span className="pg-ilpn-info-value">{formatShipTo(palletGroupRow)}</span>
            </div>
            <div>
              <span className="pg-ilpn-info-label">Sorting Rule</span>
              <span className="pg-ilpn-info-value">{palletGroupRow.sortingRule}</span>
            </div>
            <div>
              <span className="pg-ilpn-info-label">Total ILPNs</span>
              <span className="pg-ilpn-info-value">{palletGroupRow.totalILPNs}</span>
            </div>
          </div>
          {!loading && !loadError && withCartonStatus ? (
            <table className="pg-modal-table pg-ilpn-status-table">
              <thead>
                <tr>
                  <th>ILPN</th>
                  <th>Diverted</th>
                  <th>Palletised</th>
                </tr>
              </thead>
              <tbody>
                {ilpnIds.map((id, index) => (
                  <tr key={id}>
                    <td className="pg-cell-strong">{id}</td>
                    <td>
                      {index < diverted ? (
                        <span className="pg-yn pg-yn--yes">Y</span>
                      ) : (
                        <span className="pg-yn pg-yn--no">N</span>
                      )}
                    </td>
                    <td>
                      {index < palletised ? (
                        <span className="pg-yn pg-yn--yes">Y</span>
                      ) : (
                        <span className="pg-yn pg-yn--no">N</span>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : !loading && !loadError ? (
            <div className="pg-ilpn-table">
              <div className="pg-ilpn-table__header">ILPN</div>
              <ul className="pg-ilpn-table__body">
                {ilpnIds.map((id) => (
                  <li key={id}>{id}</li>
                ))}
              </ul>
            </div>
          ) : null}
        </div>
        <div className="pg-modal__footer">
          <ButtonStyled
            appearance="primary"
            type="button"
            className="pg-btn-reset"
            onClick={onClose}
          >
            Close
          </ButtonStyled>
        </div>
      </div>
    </div>
  );
}

export default PgIlpnModal;
